import { ACTION } from '../actions';
import { getFromLocalStorage } from '../../components/Helpers/Helpers';

const initialState = {
	maintenance: [],
	brands: mapPartTypes(getFromLocalStorage('BrandsAndTypes', [])),
	t: getFromLocalStorage('t') || {},
	knownLacks: getFromLocalStorage('lacks', []),
};

const store = (state = initialState, action) => {
	let payload = action.payload;

	switch (action.type) {
	case ACTION.ADD_ALL_BRANDS: {
		localStorage.setItem('BrandsAndTypes', JSON.stringify(payload));

		return {
			...state,
			brands: [...mapPartTypes(payload)],
		};
	}
	case ACTION.ADD_BRAND_TYPE: {
		const brandsAndTypes = getFromLocalStorage('BrandsAndTypes', []);
		brandsAndTypes.push(payload);
		localStorage.setItem('BrandsAndTypes', JSON.stringify(brandsAndTypes));

		return {
			...state,
			brands: [...mapPartTypes(brandsAndTypes)],
		};
	}
	case ACTION.SET_TRANSLATIONS: {
		if (payload) {
			localStorage.setItem('t', JSON.stringify(payload));
		}

		return {
			...state,
			t: payload,
		};
	}
	case ACTION.ADD_LACK: {
		const knownLacks = getFromLocalStorage('lacks', []);
		knownLacks.push(payload);
		localStorage.setItem('lacks', JSON.stringify(knownLacks));

		return {
			...state,
			knownLacks,
		};
	}
	case ACTION.ADD_ALL_LACKS: {
		localStorage.setItem('lacks', JSON.stringify(payload));

		return {
			...state,
			knownLacks: payload,
		};
	}
	default: {
		return state;
	}
	}
};

/**
 * Maps part types to useful objects
 *
 * @param	{Array} partTypes
 * @return {Array}
 */
function mapPartTypes (partTypes) {
	/**
	 * takes array with this object signature:
	 *
	 * {
	 *		 "part_type_fk_part_id": "80",
	 *		 "part_type_brand": "philips",
	 *		 "part_type_serial_number": "lamp 1",
	 *		 "selected": "0"
	 * },
	 * {
	 *		 "part_type_fk_part_id": "80",
	 *		 "part_type_brand": "philips",
	 *		 "part_type_serial_number": "lamp 2",
	 *		 "selected": "0"
	 * },
	 * {
	 *		 "part_type_fk_part_id": "80",
	 *		 "part_type_brand": "sony",
	 *		 "part_type_serial_number": "tk-123",
	 *		 "selected": "0"
	 * },
	 * {
	 *		"part_type_fk_part_id": "81",
	 *		"part_type_brand": "sony",
	 *		"part_type_serial_number": "tk-456",
	 *		"selected": "0"
	 * }
	 *
	 * and creates this:
	 *
	 * {
	 *	 '80': {
	 *		 philips: [ 'lamp 1', 'lamp 2' ],
	 *		 sony: [ 'tk-123' ]
	 *	 },
	 *	 '81': {
	 *		 sony: [ 'tk-456' ],
	 *	 },
	 * }
	 *
	 * then, this:
	 *
	 * [
	 *	 {
	 *		 id: '80',
	 *		 brand: 'philips',
	 *		 serials: [ 'lamp 1', 'lamp 2' ]
	 *	 },
	 *	 {
	 *		 id: '80',
	 *		 brand: 'sony',
	 *		 serials: [ 'tk-123' ]
	 *	 },
	 *	 {
	 *		 id: '81',
	 *		 brand: 'sony',
	 *		 serials: [ 'tk-456' ]
	 *	 },
	 * ]
	 *
	 */

	const intermediateObject = partTypes.reduce((collection, item) => {
		const id = Number(item.part_type_fk_part_id);
		if (collection[id]) {
			if (collection[id][item.part_type_brand]) {
				collection[id][item.part_type_brand].push(item.part_type_serial_number);
			} else {
				collection[id][item.part_type_brand] = [item.part_type_serial_number];
			}
		} else {
			collection[id] = {
				[item.part_type_brand]: [item.part_type_serial_number],
			};
		}
		return collection;
	}, {});

	const mapped = Object.keys(intermediateObject).reduce((collection, id) => {
		const brandsById = intermediateObject[id];
		const groupedBrands = Object.keys(brandsById).reduce((item, brand) => {
			const brandWithSerials = {
				id,
				brand,
				serials: [...new Set(brandsById[brand])], // unique values only, https://stackoverflow.com/a/14438954/554821
			};
			return [ ...item, ...[ brandWithSerials ] ];
		}, []);
		return [ ...collection, ...groupedBrands ];
	}, []);

	return mapped;
}

export default store;
